<template lang='pug'>
  .article-show(v-if='article')
    back-icon
    .article-title(v-text='article.name')
    .article-line
    .article-body(v-html='article.body')
</template>

<script>
import BackIcon from './back-icon.vue'
import { fullUrl } from '@/modules/services/utilities'

import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('faq')

export default {
  components: {
    BackIcon
  },

  data () {
    return {
      article: null
    }
  },

  computed: {
    ...mapGetters(['objectBySlug']),
    ...mapState(['articles']),

    articleId () {
      return this.$route.params['articleId']
    }
  },

  watch: {
    articleId (newVal) {
      if (newVal) {
        this.setArticle()
      }
    }
  },

  mounted () {
    this.setArticle()
  },

  methods: {
    ...mapActions(['fetchArticle']),

    setArticle () {
      this.article = this.objectBySlug('articles', this.articleId)

      if (!this.article) {
        this.fetchArticle(this.articleId).then((data) => {
          this.article = data
          this.updateSeo()
        })
      } else {
        this.updateSeo()
      }
    },

    updateSeo () {
      this.$store.commit('setSeoMetaTitle', this.article.name)
      this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
      this.$store.commit('setSeoUpdate', true)
    }
  }
}
</script>

<style lang='scss'>
  .article-body {
    img {
      height: auto;
      max-width: 100%;
    }

    .wysiwyg-underline {
      text-decoration: underline;
    }

    .wysiwyg-text-align-center {
      text-align: center;
    }

    h1, h2, h3, h4, h5, h6, p, div, span {
      margin: inherit;
      padding: inherit;
    }

    ul, ol {
      margin: 10px 0px 5px 25px;
    }

    li {
      list-style: inherit;
    }

    strong {
      @include font-weight-bold;
    }
  }
</style>

<style scoped lang='scss'>
  .article-show {
    @include media-breakpoint-down(md) {
      margin-left: 5px;
      margin-right: 8px;
    }
  }

  .article-title {
    @include font-weight-bold;
    font-size: 14px;
    font-weight: 600;
  }

  .article-line {
    height: 1px;
    margin-top: 8px;
    background-color: $grey;
  }

  .article-body {
    margin-top: 20px;

    @include media-breakpoint-up(sm) {
      width: 70%;
    }
  }
</style>
